import { render } from "./form5.vue?vue&type=template&id=5fe4703c&scoped=true"
import script from "./form5.vue?vue&type=script&lang=js"
export * from "./form5.vue?vue&type=script&lang=js"

import "./form5.vue?vue&type=style&index=0&id=5fe4703c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe4703c"]])

export default __exports__